module.exports = __webpack_public_path__ + "static/media/image_partners_fitcann.2e9ecf7f.jpg";